export type UserCvProfile = {
  url: string | null;
  updatedAt: string | null;
  visibleOnProfile: boolean;
};

export function parseUserCvFromProfile(data: Record<string, unknown> | null | undefined): UserCvProfile {
  if (!data) {
    return { url: null, updatedAt: null, visibleOnProfile: false };
  }
  const urlRaw = data.cv_url ?? data.cvUrl;
  const url = typeof urlRaw === "string" && urlRaw.trim().length > 0 ? urlRaw.trim() : null;
  const updatedRaw = data.cv_updated_at ?? data.cvUpdatedAt;
  const updatedAt =
    typeof updatedRaw === "string" && updatedRaw.trim().length > 0 ? updatedRaw : null;
  const visibleRaw = data.cv_visible ?? data.cvVisible;
  const visibleOnProfile = visibleRaw === true || visibleRaw === "true";
  return { url, updatedAt, visibleOnProfile };
}

export function formatUserCvUpdatedAt(value: string | null): string | null {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString("es-AR", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}

export function hasCvProfileChanges(
  saved: UserCvProfile,
  draft: { cvFile: File | null; cvVisible: boolean }
): boolean {
  return Boolean(draft.cvFile) || draft.cvVisible !== saved.visibleOnProfile;
}

export function resolveApplicationCvForPostulation(options: {
  cvFile: File | null;
  useProfileCv: boolean;
  profileCvUrl: string | null;
}): File | "" {
  const { cvFile, useProfileCv, profileCvUrl } = options;
  if (cvFile) return cvFile;
  if (useProfileCv && profileCvUrl) return "";
  return "";
}

export function applicationCvIsProvided(options: {
  cvFile: File | null;
  useProfileCv: boolean;
  profileCvUrl: string | null;
}): boolean {
  return Boolean(options.cvFile) || (options.useProfileCv && Boolean(options.profileCvUrl));
}

export function getCvFileNameFromUrl(url: string): string {
  try {
    const pathname = new URL(url).pathname;
    const segment = pathname.split("/").filter(Boolean).pop();
    if (segment) return decodeURIComponent(segment);
  } catch {
    /* ignore */
  }
  return "CV.pdf";
}
